// Cookie-Einwilligung: einfache Zustimmung (kein granulares Consent-Management),
// wird per localStorage persistiert. Login/Register prüfen diesen Status, um die
// Anmeldung erst nach Zustimmung zuzulassen.

const STORAGE_KEY = 'cookieConsent';
export const COOKIE_CONSENT_EVENT = 'cookieConsentChanged';

export const hasCookieConsent = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'accepted';
  } catch (e) {
    return false;
  }
};

export const acceptCookieConsent = () => {
  try {
    localStorage.setItem(STORAGE_KEY, 'accepted');
  } catch (e) {
    // localStorage nicht verfügbar (z.B. privater Modus) - Zustimmung gilt nur für diese Session
  }
  window.dispatchEvent(new Event(COOKIE_CONSENT_EVENT));
};
